import { UPDATE_CURRENT_USER, TOGGLE_INSTA_ORDER_CREATE_MODAL, TOGGLE_INSTA_BULK_ORDER_MODAL, TOGGLE_INSTA_VIRTUAL_ACCOUNT_MODAL } from '../constants/action-types.js';

export const updateCurrentUserAction = (user) => {
  return { type: UPDATE_CURRENT_USER, payload: { user } };
}

export const toggleCreateOrderModalAction = () => {
  return { type: TOGGLE_INSTA_ORDER_CREATE_MODAL, payload: {} };
}

export const toggleBulkOrderModalAction = () => {
  return { type: TOGGLE_INSTA_BULK_ORDER_MODAL, payload: {} };
}

export const toggleVirtualAccountModalAction = () => {
  return { type: TOGGLE_INSTA_VIRTUAL_ACCOUNT_MODAL, payload: {} };
}

